import React from 'react';
import { withRouter} from 'react-router-dom';
// Router
import {routes,RouteWithSubRoutes} from './routes';
// Components
import Auth from './components/Auth';

// UI
import {Container} from '@material-ui/core';

const Wos=(props:any)=>{
    return(
        
          <Auth>
            
              <Container maxWidth="xl" className="container">
                {routes.map((route, i) => (
                  <RouteWithSubRoutes key={i} {...route} />
                ))}
              </Container>
            
          </Auth>
        
    )
}

export default withRouter(Wos);